var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event)?_c('v-card',{staticClass:"mb-10",attrs:{"outlined":"","loading":_vm.loading}},[_c('Top'),_c('Tickets'),_c('Middle'),_c('Map')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }